// import components
import { styled, Box } from '@mui/material';

export const StyledDrawerFooterMainBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  borderTop: `1px solid ${theme.palette.divider}`,
  position: 'sticky',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: 'white',
  zIndex: 2,
  marginTop: 'auto',
  marginLeft: theme.spacing(-5),
  marginRight: theme.spacing(-5),
  padding: theme.spacing(5)
}));

export const StyledDrawerFooterInnerBox = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  gap: theme.spacing(6),
  marginLeft: 'auto'
}));
